import React, { useEffect } from 'react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Stack,
    Select,
    Text,
    Box,
} from '@chakra-ui/react'
import Input from './Input';
import { useState } from 'react';
import { FaProductHunt, FaUser, FaUserAlt } from "react-icons/fa";
import Button from './Button';
import { CreateShelf, CreateUser, GetAllCategories, GetAllName, GetAllStores, IntegrateApi, TransferStoreApi, UpdateProductShelf } from '../Utils/ApiCalls';
import { SiQuantcast } from 'react-icons/si';
import { CgProductHunt } from 'react-icons/cg';
import { ImPriceTags } from 'react-icons/im';
import MsgCallback from './MsgCallback';
import { isEmergency } from '../Authetication';



export default function CreateShelfModal({ isOpen, onOpen, onClose, state, updatedPayload, sendingId }) {

    const [Payload, setPayload] = useState({
        productname: "",
        productshelfid: "",
        store: "",
        category: ""
    });

    const [Emergency, setEmergency] = useState(isEmergency());

    const [UpdateShelfPayload, setUpdateShelfPayload] = useState({
        id: "",
        productname: "",
        productshelfid: "",
        category: ""
    });

    const [TransferPayload, setTransferPayload] = useState({
        receivingstoreid: "",
        qtytotransfer: "",
        pricetransfer: "",

    });

    const [MigratePayload, setMigratePayload] = useState({
        fordeviceassignment: false,
        exactnameondeviceassigment: "",
      

    });

    const [Data, setData] = useState([]);
    const [DataName, setDataName] = useState([]);
    const [CategoryData, setCategoryData] = useState([]);



    const [errorMsg, setErrorMsg] = useState({
        status: false,
        msg: ""
    });

    const [SuccessMsg, setSuccessMsg] = useState({
        status: false,
        msg: ""
    });


    const [Loading, setLoading] = useState(false);


    // Onchange handler for NewSelf
    const handleNewShelf = (e) => {
        console.log("e", e.target);
        console.log("store",Data );
        setPayload({ ...Payload, [e.target.id]: e.target.value });
        console.log("Payload", Payload);

    }
    // Onchange handler for Updated Self
    const handleUpdatedShelf = (e) => {
        setUpdateShelfPayload({ ...UpdateShelfPayload, [e.target.id]: e.target.value })

    }
    // Onchange handler for Store transfer
    const handleTransfer = (e) => {
        setTransferPayload({ ...TransferPayload, [e.target.id]: e.target.value })

    }
    const handleMigrate = (e) => {
        setMigratePayload({ ...MigratePayload, [e.target.id]: e.target.value })

    }

    // console.log("TransferPayload", TransferPayload)




    //get all stores from database
    const AllStores = async () => {
        let result = await GetAllStores()

        if (result.status === true) {
            setData(result.queryresult)
        }
    }
    const AllName = async () => {
        let result = await GetAllName()

        console.log("All name", result)

        if (result.status === true) {
            setDataName(result.queryresult)
        }
    }
    //get categories stores from database
    const AllCategories = async () => {
        let result = await GetAllCategories()
        // console.log();

        if (result.status === true) {
            setCategoryData(result.queryresult.categorydetails)
        }
    }


    const CreateNewShelf = async () => {

        try {
            setLoading(true)
            let result = await CreateShelf(Payload);
            // console.log("result", result);
            if (result.status === true) {
                setLoading(false)
                setSuccessMsg({
                    status: true,
                    msg: "Product Shelf created successfully"
                })

                setPayload({
                    productname: "",
                    productshelfid: "",
                    store: "",
                    category: ""
                })

                setTimeout(() => {
                    setSuccessMsg({
                        status: false,

                    })
                }, 3000);

            } else {
                setLoading(false)
                setErrorMsg({
                    status: true,
                    msg: result.msg
                })

                setTimeout(() => {
                    setErrorMsg({
                        status: false,

                    })
                }, 3000);

            }


        } catch (e) {

            setLoading(false)
            setErrorMsg({
                status: true,
                msg: e.message
            })
            console.error('Error:', e.message);
        }



    }

    //update function for the Product shelf
    const UpdatedShelf = async () => {

        try {
            setLoading(true)
            let result = await UpdateProductShelf(UpdateShelfPayload, UpdateShelfPayload.id);
            // console.log("result", result);
            if (result.status == true) {
                setLoading(false)
                setSuccessMsg({
                    status: true,
                    msg: "Product Shelf Updated successfully"
                })


                setTimeout(() => {
                    setSuccessMsg({
                        status: false,

                    })

                    onClose()
                }, 3000);

            } else {
                setLoading(false)
                setErrorMsg({
                    status: true,
                    msg: result.msg
                })

                setTimeout(() => {
                    setErrorMsg({
                        status: false,

                    })
                }, 3000);

            }


        } catch (e) {

            setLoading(false)
            setErrorMsg({
                status: true,
                msg: e.message
            })
            console.error('Error:', e.message);
        }



    }
    //Transfer function for the store
    const TransferStore = async () => {

        try {
            setLoading(true)
            let result = await TransferStoreApi(TransferPayload, sendingId);
            console.log("result", result);
            if (result.status == true) {
                setLoading(false)
                setSuccessMsg({
                    status: true,
                    msg: "Product Shelf Updated successfully"
                })

                setErrorMsg({
                    status: false,
                    msg: result.msg
                })


                setTimeout(() => {
                    setSuccessMsg({
                        status: false,

                    })

                    onClose()
                }, 3000);

            } else {
                setLoading(false)
                setErrorMsg({
                    status: true,
                    msg: result.msg
                })

                setTimeout(() => {
                    setErrorMsg({
                        status: false,

                    })
                }, 5000);

            }


        } catch (e) {

            setLoading(false)
            setErrorMsg({
                status: true,
                msg: e.message
            })
            console.error('Error:', e.message);
        }



    }
    const Integrate = async () => {

        try {
            setLoading(true)
            let result = await IntegrateApi({
                fordeviceassignment: MigratePayload.fordeviceassignment == "true" ? true : false,
                exactnameondeviceassigment: MigratePayload.exactnameondeviceassigment
            }, sendingId);
            console.log("result", result);

            if (result.status == true) {
                setLoading(false)
                setSuccessMsg({
                    status: true,
                    msg: "Product Shelf Integrated successfully"
                })

                setErrorMsg({
                    status: false,
                    msg: result.msg
                })


                setTimeout(() => {
                    setSuccessMsg({
                        status: false,

                    })

                    onClose()
                }, 3000);

            } else {
                setLoading(false)
                setErrorMsg({
                    status: true,
                    msg: result.msg
                })

                setTimeout(() => {
                    setErrorMsg({
                        status: false,

                    })
                }, 5000);

            }


        } catch (e) {

            setLoading(false)
            setErrorMsg({
                status: true,
                msg: e.message
            })
            console.error('Error:', e.message);
        }



    }

    useEffect(() => {
        AllStores();
        AllName()
        AllCategories();
        //onLoad of the screen updates the Updated shelf payload coming from the Manage shelf page 
        setUpdateShelfPayload({
            id: updatedPayload.id,
            productname: updatedPayload.name,
            productshelfid: updatedPayload.shelfId,
            store: updatedPayload.store,
            category: updatedPayload.category
        })
    }, [isOpen]);

    return (



        <Modal isOpen={isOpen} onClose={onClose} isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>{state == "Product Shelf" ? `Create New ${state}` : state}</ModalHeader>
                <ModalCloseButton />
                <ModalBody>

                    {
                        state == "Product Shelf" ? (
                            <Box>
                                <Stack spacing={"15px"}>
                                    <Input leftIcon={<FaProductHunt />} iconColor="black" labelBg='#fff' label='Product Name' id="productname" type='text' value={Payload.productname} val={Payload.productname != "" ? true : false} onChange={handleNewShelf} />
                                    <Input leftIcon={<CgProductHunt />} iconColor="black" labelBg='#fff' label='Product Shelf Id' id="productshelfid" type='text' value={Payload.productshelfid} val={Payload.productshelfid != "" ? true : false} onChange={handleNewShelf} />

                                    <Select _focus={{ borderColor: "blue.blue400" }} borderColor={"#242424"} placeholder='Select Category' fontWeight={"400"} fontSize={Payload.category != "" ? "16px" : "12px"} id='category' value={Payload.category} onChange={handleNewShelf} >
                                        {
                                            CategoryData.map((item, i) => (

                                                <option value={`${item._id}`}>{item.name}</option>
                                            ))
                                        }

                                    </Select>

                                    {
                                        Emergency && (
                                            <Select _focus={{ borderColor: "blue.blue400" }} placeholder='Select Store' fontWeight={"400"} fontSize={Payload.store != "" ? "16px" : "12px"} id='store' value={Payload.store} onChange={handleNewShelf} >
                                                {
                                                    Data.filter(item => item.value != 1).map((item, i) => (

                                                        <option value={`${item.value}`}>{item.name}</option>
                                                    ))
                                                }

                                            </Select>
                                        )
                                    }

                                </Stack>

                                <Button mt="14px" isLoading={Loading}
                                    disabled={Payload.productname != "" && Payload.productshelfid != "" && Payload.category != "" ? false : true}
                                    onClick={CreateNewShelf}>Create new Product Shelf</Button>

                                <MsgCallback errorMsg={errorMsg} SuccessMsg={SuccessMsg} />

                            </Box>
                        ) : (

                            state == "Update Product Shelf" ? (
                                <Box>
                                    <Stack spacing={"15px"}>
                                        <Input leftIcon={<FaProductHunt />} iconColor="black" labelBg='#fff' label='Product Name' id="productname" type='text' value={UpdateShelfPayload.productname} val={UpdateShelfPayload.productname != "" ? true : false} onChange={handleUpdatedShelf} />
                                        <Input leftIcon={<CgProductHunt />} iconColor="black" labelBg='#fff' label='Product Shelf Id' id="productshelfid" type='text' value={UpdateShelfPayload.productshelfid} val={UpdateShelfPayload.productshelfid != "" ? true : false} onChange={handleUpdatedShelf} />




                                        <Select _focus={{ borderColor: "blue.blue400" }} placeholder='Select Category' fontWeight={"400"} fontSize={UpdateShelfPayload.category != "" ? "16px" : "12px"} id='category' value={UpdateShelfPayload.category} onChange={handleUpdatedShelf} >
                                            {
                                                CategoryData.map((item, i) => (

                                                    <option value={`${item._id}`}>{item.name}</option>
                                                ))
                                            }

                                        </Select>

                                        {
                                        Emergency && (
                                            <Select _focus={{ borderColor: "blue.blue400" }} placeholder='Select Store' fontWeight={"400"} fontSize={UpdateShelfPayload.store != "" ? "16px" : "12px"} id='store' value={UpdateShelfPayload.store} onChange={handleUpdatedShelf} >
                                                {
                                                    Data.filter(item => item.value != 1).map((item, i) => (

                                                        <option value={`${item._id}`}>{item.name}</option>
                                                    ))
                                                }

                                            </Select>
                                        )
                                    }
                                    </Stack>

                                    <Button mt="14px" isLoading={Loading}
                                        disabled={UpdateShelfPayload.productname != "" && UpdateShelfPayload.productshelfid != "" && UpdateShelfPayload.store != "" && UpdateShelfPayload.category != "" ? false : true}
                                        onClick={UpdatedShelf}>Update Product Shelf</Button>

                                    <MsgCallback errorMsg={errorMsg} SuccessMsg={SuccessMsg} />

                                </Box>
                            ) : (

                                state === "Transfer Store" ? (
                                    <Box>
                                    <Stack spacing={"15px"}>

                                        <Select _focus={{ borderColor: "blue.blue400" }} placeholder='Select Receiving Store' fontWeight={"400"} fontSize={TransferPayload.receivingstoreid != "" ? "16px" : "12px"} id='receivingstoreid' value={TransferPayload.receivingstoreid} onChange={handleTransfer}>
                                            {
                                                Data.map((item, i) => (

                                                    <option value={`${item.value}`}>{item.name}</option>
                                                ))
                                            }
                                        </Select>

                                        <Input leftIcon={<SiQuantcast />} iconColor="black" labelBg='#fff' label='Quantity to Transfer' id="qtytotransfer" type='number' value={TransferPayload.qtytotransfer} val={TransferPayload.qtytotransfer != "" ? true : false} onChange={handleTransfer} />



                                    </Stack>

                                    <Button mt="14px" isLoading={Loading}
                                        disabled={TransferPayload.receivingstoreid != "" && TransferPayload.qtytotransfer != ""  ? false : true}
                                        onClick={TransferStore}>Transfer Store</Button>

                                    <MsgCallback errorMsg={errorMsg} SuccessMsg={SuccessMsg} />

                                </Box>
                                ):(

                                    <Box>
                                    {/* This is for migrating to device assignment */}
                                    <Stack spacing={"15px"}>

                                        <Select _focus={{ borderColor: "blue.blue400" }} placeholder='Select For Device Assignment' fontWeight={"400"} fontSize={MigratePayload.fordeviceassignment != "" ? "16px" : "12px"} id='fordeviceassignment' value={MigratePayload.fordeviceassignment} onChange={handleMigrate}>
                                                    <option value={true}>True</option>
                                                    <option value={false}>False</option>
                                          
                                          
                                        </Select>
                                        <Select _focus={{ borderColor: "blue.blue400" }} placeholder='Select Name on Device Assignment' fontWeight={"400"} fontSize={MigratePayload.exactnameondeviceassigment != "" ? "16px" : "12px"} id='exactnameondeviceassigment' value={MigratePayload.exactnameondeviceassigment} onChange={handleMigrate}>
                                            {
                                                DataName.map((item, i) => (

                                                    <option value={`${item}`}>{item}</option>
                                                ))
                                            }
                                        </Select>




                                    </Stack>

                                    <Button mt="14px" isLoading={Loading}
                                        disabled={MigratePayload.exactnameondeviceassigment != "" && MigratePayload.fordeviceassignment != ""  ? false : true}
                                        onClick={Integrate}>Integrate to Device Assignment</Button>

                                    <MsgCallback errorMsg={errorMsg} SuccessMsg={SuccessMsg} />

                                </Box>
                                )
                               
                            )

                        )
                    }







                </ModalBody>

                <ModalFooter>


                </ModalFooter>
            </ModalContent>
        </Modal>

    )
}
